/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2023 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceTypes } from "../icetypes";
import { accountingperiod } from './accountingperiod';

export class accountingperiodindex extends accountingperiod {
  accounting_period_index_key: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "ACCOUNTING_PERIOD_INDEX";
  }
}
